/*
  Global App CSS (Document Level Styles)
  ----------------------
  Use this file for styles that should be applied to all components.
  For example, "font-family" within the "body" selector is a CSS property
  most apps will want applied to all components.

  Any global CSS variables should also be applied here.
*/

/*
  The imports below are needed to include our light dom css for global styles such as fonts and colors.
  You can comment out any of these imports if you do not need that css. For example, if you have your own
  global font family css then you can comment out the typography.css import.
*/

/** Core CSS required for ionic components to work property */
@import '~@ionic/core/css/core.css';

/** Basic CSS for apps built with Ionic */
@import '~@ionic/core/css/normalize.css';
@import '~@ionic/core/css/structure.css';
@import '~@ionic/core/css/typography.css';

/** Optional CSS utils that can be commented out */
@import '~@ionic/core/css/padding.css';
@import '~@ionic/core/css/float-elements.css';
@import '~@ionic/core/css/text-alignment.css';
@import '~@ionic/core/css/text-transformation.css';
@import '~@ionic/core/css/flex-utils.css';
@import '~@ionic/core/css/display.css';

/*
  The CSS Variables below can be used to theme your app.
  For more info on CSS variables check out:
  https://developer.mozilla.org/en-US/docs/Web/CSS/Using_CSS_variables

  More info about color theming using Ionic:
  https://ionicframework.com/docs/theming/color-generator
*/

@import './styles/variables.css';
@import './styles/modals.css';
@import './styles/typography.css';
@import './styles/spacing.css';
@import './styles/concourse-popover.css';

:root {
  /* Ionic breakpoints */
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;

  /* New backgroung color following the new design */
  --ion-background-color: #121212;
  --ion-background-color-rgb: 255, 255, 255;

  --ion-text-color: #e0e0e0;
  --ion-text-color-rgb: 0, 0, 0;

  --ion-color-step-50: #f2f2f2;
  --ion-color-step-100: #e6e6e6;
  --ion-color-step-150: #d9d9d9;
  --ion-color-step-200: #cccccc;
  --ion-color-step-250: #bfbfbf;
  --ion-color-step-300: #b3b3b3;
  --ion-color-step-350: #a6a6a6;
  --ion-color-step-400: #999999;
  --ion-color-step-450: #8c8c8c;
  --ion-color-step-500: #808080;
  --ion-color-step-550: #737373;
  --ion-color-step-600: #666666;
  --ion-color-step-650: #595959;
  --ion-color-step-700: #4d4d4d;
  --ion-color-step-750: #404040;
  --ion-color-step-800: #333333;
  --ion-color-step-850: #e0e0e0;
  --ion-color-step-900: #191919;
  --ion-color-step-950: #0d0d0d;

  --color-primary-1: #f9ce03;

  --color-primary-2: #fbe167;
  --color-primary-3: #594f1f;
  --color-secondary-1: #2196f3;
  --color-secondary-2: #1e88e5;
  --color-secondary-3: #3b3340;
  --color-warning-1: #e52011;
  --color-warning-2: #ef7970;
  --color-warning-3: #572724;
  --color-success-1: #8bc34a;
  --color-success-2: #b9db92;
  --color-success-3: #424f32;
  --color-background-1: #222222;
  --color-background-2: #292929;
  --color-background-3: #2d2d2d;
  --color-background-4: #888888;
  --color-foreground-1: #e0e0e0;
  --color-foreground-2: #aaaaaa;
  --color-foreground-3: #8a8a8a;
  --color-grey-1: #333333;
  --color-grey-2: #393939;
  --color-grey-3: #4e4e4e;
  --color-grey-4: #6d6c6c;
  --color-grey-5: #bcbcbc;
  --color-button-text-1: #222222;
  --color-button-text-2: #ffffff;
  --color-disabled-1: #242424;
  --color-disabled-2: #4b4b4b;
  --color-shadow: #00000026;
  --radius: 6px;

  --background-color-step-50: #1c1c1c;
  --background-color-step-100: #272727;
  --background-color-step-150: #313131;
  --background-color-step-200: #3b3b3b;
  --background-color-step-250: #464646;
  --background-color-step-300: #505050;
  --background-color-step-350: #5a5a5a;
  --background-color-step-400: #646464;
  --background-color-step-450: #6f6f6f;
  --background-color-step-500: #797979;
  --background-color-step-550: #838383;
  --background-color-step-600: #8e8e8e;
  --background-color-step-650: #989898;
  --background-color-step-700: #a2a2a2;
  --background-color-step-750: #adadad;
  --background-color-step-800: #b7b7b7;
  --background-color-step-850: #c1c1c1;
  --background-color-step-900: #cbcbcb;
  --background-color-step-950: #d6d6d6;

  /*--safe-area-inset-bottom: 48px;
  --safe-area-inset-top: 38px;*/
}

/**
 * The default loading spinner is white on a black background.
 * This is a fix to make it black on a light background.
 */
ion-loading.sc-ion-loading-md-h,
ion-loading.sc-ion-loading-ios-h {
  --background: var(--background-color-step-100);
}

.safe-area-bottom {
  margin-bottom: var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px));
}

.link {
  cursor: pointer;
  transition: all 0.2s ease;
  color: var(--color-primary-1);
  text-decoration: none;
}

.link:hover {
  color: var(--color-primary-2);
  text-decoration: underline;
}

.link-button {
  --color: var(--color-primary-1);
  text-decoration: underline;
  padding: 0;
  margin: 0;
  height: auto;
  min-height: unset;
  font-size: inherit;
  text-transform: none;
  font-weight: normal;
}

.link-button ion-icon {
  color: white;
}

.center-content {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.cc-scrollbars {
  scrollbar-width: thin;
  scrollbar-color: grey transparent;
  /* scrollbar-gutter: stable; causing extra gaps on concourse-menu */
  overflow-y: auto;
}

/* right alinging a searchbar in the header also right aligns the text... this fixes that */
/* ion-searchbar prefix beats Ionic scoped host rules (.sc-ion-searchbar-md-h) on the same element */
ion-searchbar.cc-searchbar {
  text-align: left;
  max-width: 400px;
  --border-radius: 20px;
  --background: var(--ion-color-tertiary);
  --cancel-button-color: var(--ion-text-color);
}

.button-rounded-corners {
  --border-radius: 16px !important;
}

.width-100 {
  width: 100%;
}

.height-100 {
  height: 100%;
}

.size-100 {
  width: 100%;
  height: 100%;
}

ion-toolbar {
  /* whatever nitwit thought it was a good idea that layout components came with background colors...*/
  --background: transparent;
}

.toolbar-separator {
  width: 1px;
  height: 1.5rem;
  background-color: var(--ion-color-step-250);
  opacity: 0.3;
  margin: 0 0.25rem;
  align-self: center;
}

ion-accordion-group,
ion-accordion {
  font-size: 14px;
}

.ion-accordion-toggle-icon {
  color: var(--ion-color-light);
}

.cc-no-line-accordion ion-accordion ion-item {
  --border-width: 0;
  --inner-border-width: 0;
}
.cc-no-line-list ion-item {
  --border-color: 'transparent';
  --inner-border-width: 0;
}

ion-textarea,
ion-input {
  font-size: 14px;
  /* New color for better contrasting  */
  --background: var(--ion-color-step-750) !important;
  --color: var(--ion-text-color) !important;
  /* --border styles appear to do nothing */
  /* Doing the inputs a bit rounder */
  --border-radius: 10px !important;
  --border-style: solid !important;
  --border-width: 1px !important;
  --border-color: var(--ion-color-step-800) !important;
  --padding-start: 5px !important;
  /* these styles aren't needed */
  /* border: 1px solid var(--ion-color-step-800) !important; */
  /* border-radius: 5px !important; */
}

/* remove bottom highlight ribbon */
ion-input .input-highlight,
ion-textarea .textarea-highlight {
  display: none !important;
}

/*
 * used to create vertical space between stacked input fields
 * the ionic utility class "ion-margin-bottom" has margin of 16px and looks too big
 */
.cc-margin-bottom {
  margin-bottom: 10px;
}

/*
 * the ionic utility class "ion-padding" has padding of 16px and looks too big.
 * Here we use 10px as a more reasonable padding.
 */
.cc-padding {
  padding: 10px;
}

.cc-padding-vertical {
  padding: 10px 0px;
}

.cc-padding-horizontal {
  padding: 0 10px;
}

.cc-padding-end {
  padding-right: 10px;
}

.cc-padding-start {
  padding-left: 10px;
}
.cc-padding-top {
  padding-top: 10px;
}
.cc-padding-bottom {
  padding-bottom: 10px;
}

/** The new designs have a floating create button bottom right on mobile screens */
.floating-create-button {
  position: absolute;
  bottom: 12px;
  right: 16px;
}

.dark-background {
  background-color: var(--background, black);
}

/**
 * These classes are used to set the color of the buttons in the alerts.
 * Must be defined in the root app.css file so they are available globally.
 */
.color-danger {
  color: var(--ion-color-danger) !important;
}
.color-white {
  color: white !important;
}

.no-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
}

ion-chip {
  color: var(--ion-text-color, white);
}

/**
 * By default the icons come in white color and this is not bad
 * if they are loose or alone. But when they are contained in a
 * primary color button (main yellow of the page).
 * This color of the icon should match the design and
 * visibility which is to have a darker color.
 * This validation helps it fit into the dark scheme.
 */
ion-button[color='primary'] ion-icon {
  color: var(--ion-background-color);
}

/**
 * We want button icons to be white when they are alone
 */
ion-button ion-icon[slot='icon-only'] {
  color: var(--ion-text-color);
}

/**
  * Unchecked checkboxes are dark making them almost invisible on the dark background.
  * This is a fix to make them visible.
  */
ion-checkbox {
  --border-color: var(--color-primary-1, yellow);
}

/**
 * Unchecked radio buttons are dark making them almost invisible on the dark background.
 * This is a fix to make them visible.
 */
ion-radio {
  --color: var(--color-primary-1, yellow);
}

/* Many ionic stules come with background colors which we may not want */
.transparent-background {
  background-color: transparent !important;
  --ion-background-color: transparent;
  --background: transparent !important;
}

.input-icon {
  padding-right: 10px;
  font-size: 24px;
}

/**
 * We have a common desigh where we have what looks like an input field
 * but it contains such things as tags, people chips or date selectors
 */
.pseudo-input-editable,
.pseudo-input {
  color: var(--ion-text-color, white);
  --color: var(--ion-text-color) !important;
  border: 1px solid var(--ion-color-step-800) !important;
  border-radius: 5px !important;
  min-height: 42px;
  margin-top: 4px;
  background-color: var(--ion-background-color) !important;
  cursor: pointer;
}

.pseudo-input > p {
  margin: 8px !important; /* center the text inside the input */
}

.pseudo-input-editable {
  background-color: var(--ion-color-step-900) !important;
}

/* Make the text small like whte labels on text inputs once they have content */
.radio-label-wrap::part(label) {
  white-space: normal;
  overflow-wrap: break-word;
  display: block;
}
